import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { DietSupplementsProvider } from "./DietSupplementsContext";
import { MedicalHistoryQuestionProvider } from "@src/packages/medical-history/components";
import { DietScreen } from "./screens/DietScreen";
import { SupplementsScreen } from "./screens/SupplementsScreen";
import { SupplementsDetailsScreen } from "./screens/SupplementsDetailsScreen";
import { DietSupplementsCompleteScreen } from "./screens/DietSupplementsCompleteScreen";

export type DietSupplementsStackParamList = {
  DietIntro: undefined;
  SupplementsIntro: undefined;
  SupplementsDetails: undefined;
  DietSupplementsComplete: undefined;
};

const Stack = createNativeStackNavigator<DietSupplementsStackParamList>();

export function DietSupplementsNavigator() {
  return (
    <DietSupplementsProvider>
      <MedicalHistoryQuestionProvider
        section="diet-supplements"
        sectionLabelKey="med_history.review.section_title.diet-supplements"
        helpTextKey="med_history.question_screen.flow_help.diet-supplements"
      >
        <Stack.Navigator
          initialRouteName="DietIntro"
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: "transparent" },
          }}
        >
          <Stack.Screen name="DietIntro" component={DietScreen} />
          <Stack.Screen name="SupplementsIntro" component={SupplementsScreen} />
          <Stack.Screen
            name="SupplementsDetails"
            component={SupplementsDetailsScreen}
          />
          <Stack.Screen
            name="DietSupplementsComplete"
            component={DietSupplementsCompleteScreen}
          />
        </Stack.Navigator>
      </MedicalHistoryQuestionProvider>
    </DietSupplementsProvider>
  );
}
